<template>
    <v-dialog v-model="dialog" max-width="600" persistent no-click-animation>
        <v-card class="card-container">
            <v-card-title class="title-container">
                {{ $t('routines.replace_routines') }}
            </v-card-title>
            <v-card-text class="mt-3">
                <v-row dense>
                    <v-col cols="12">
                        <small>
                            {{ $t('routines.already_have_routine') }}
                            <br>
                            {{ $t('routines.select_dates_to_replace_routine') }}
                        </small>
                    </v-col>
                    <v-col cols="12" md="6" v-for="(routine,i) in toReplace" :key="routine.assignedRoutineId"
                           class="pa-0">
                        <v-checkbox
                            :key="i"
                            v-model="routine.replace"
                            :label="routineLabel(routine)"
                            color="secondary"
                            hide-details dense
                        />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="px-0 pb-0">
                <v-row no-gutters>
                    <v-col cols="3">
                        <v-btn block depressed x-large class="normal-btn no-radius" @click.stop="onCancel">
                            {{ $t('common.cancel') }}
                        </v-btn>
                    </v-col>
                    <v-col cols="9">
                        <v-btn block depressed x-large color="primary" class="normal-btn no-radius black--text"
                               @click.stop="onConfirm">
                            {{ $t('common.confirm') }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {mapMutations, mapState} from 'vuex'

export default {
    name: "SelectReplaceAssignedRoutinesDatesDialog",
    props: {
        assignedRoutinesInSameDate: {
            type: Array,
            default: () => [],
        },
        name: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: 'student'
        },
        noCloseDialog: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            dialog: false,
            date: '',
            toReplace: [],
        }
    },
    computed: {
        ...mapState(['dialogActive']),
    },
    methods: {
        ...mapMutations(['setDialogActive']),
        show() {
            const vm = this
            vm.dialog = true
            if (!vm.noCloseDialog) vm.setDialogActive(true)
        },
        hide() {
            const vm = this
            vm.dialog = false
            if (!vm.noCloseDialog) vm.setDialogActive(false)
        },
        onConfirm() {
            this.$emit('confirm', this.toReplace)
            this.hide()
        },
        onCancel() {
            this.$emit('cancel')
            this.hide()
        },
        routineLabel(routine) {
            if (!routine.name) return routine.date
            return `${routine.name} - ${routine.date}`
        }
    },
    watch: {
        dialogActive(val) {
            if (!val) this.hide()
        },
        assignedRoutinesInSameDate(val) {
            this.toReplace = val
        },
    }
}
</script>

<style scoped>

.card-container {
    border-radius: 8px;
    overflow: hidden;
}

.title-container {
    color: #FFFFFF;
    background: var(--v-backGroundPrimary-base);
}

</style>